<div class="kion-youtube-container">
  <youtube-player
    videoId="{{videoId}}"
    suggestedQuality="{{quality}}"
    [startSeconds]="this.startSeconds"
    [endSeconds]="this.endSeconds"
  [width]="'100%'" >
  </youtube-player>
</div>